export default __webpack_public_path__ + "static/media/outside-right.eab3256f.jpg";